import { z } from "zod";
import { SuggestionOverrideDecision } from "./suggestion-override-decision.schemas.js";

/** Prose a promote publishes: blank is absent, not empty, so it is trimmed and required. */
export const WhyConnectProseSchema = z.string().trim().min(1);

/** The host's own note. Never shown to readers; `null` clears it. */
const noteSchema = z.string().nullable();

export const promoteOverrideContentSchema = z.object({
  decision: z.literal(SuggestionOverrideDecision.PROMOTE),
  paragraph: WhyConnectProseSchema,
  note: noteSchema,
});

export const dropOverrideContentSchema = z.object({
  decision: z.literal(SuggestionOverrideDecision.DROP),
  paragraph: z.undefined().optional(),
  note: noteSchema,
});

/**
 * What a host decided about one pair, independent of which pair it is and when they said
 * it. Discriminated on `decision`, so a promote always carries publishable prose and a
 * drop carries none — and cannot.
 *
 * This is the in-flight shape, shared by the request body and the editor that composes
 * one. A stored row spells the same absence as `paragraph: null`, because a document
 * field cannot be absent-but-typed; that difference belongs to the DB schema, not here.
 */
export const SuggestionOverrideContentSchema = z.discriminatedUnion(
  "decision",
  [promoteOverrideContentSchema, dropOverrideContentSchema],
);

export type SuggestionOverrideContentType = z.infer<
  typeof SuggestionOverrideContentSchema
>;
